module.exports = __webpack_public_path__ + "img/2.a05a56b9.png";